import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 14,
    fontSize: 9,
    fontFamily: "Helvetica",
  },
  header: {
    alignItems: "center",
    marginBottom: 10,
    position: "relative",
  },
  logo: {
    width: "80px",
    height: "auto",
    position: "absolute",
    top: "0px",
    left: "0px",
  },
  reportTitle: {
    fontSize: 14,
    color: "#000",
    marginBottom: 3,
  },
  facilityName: {
    fontSize: 12,
    color: "#1D2939",
    fontFamily: "Helvetica-Bold",
    marginBottom: 2,
  },
  reportPeriod: {
    fontSize: 11,
    color: "#344054",
    marginBottom: 2,
  },
  entryCount: {
    fontSize: 10,
    color: "#667085",
  },

  /* ── Record card ── */
  recordCard: {
    marginBottom: 6,
    border: "0.5px solid #D0D5DD",
  },
  cardHeader: {
    flexDirection: "row",
    backgroundColor: "#1D2939",
    padding: "4px 4px",
    flexWrap: "wrap",
  },
  cardHeaderItem: {
    flexDirection: "row",
    marginRight: 8,
  },
  cardLabel: {
    fontSize: 5.5,
    color: "#98A2B3",
    fontFamily: "Helvetica-Bold",
  },
  cardValue: {
    fontSize: 5.5,
    color: "#FAFAFA",
    marginLeft: 2,
  },

  /* ── Sub-table inside card ── */
  subTableHeaderRow: {
    flexDirection: "row",
    backgroundColor: "#F2F4F7",
    borderTop: "0.5px solid #E4E7EC",
  },
  subTableHeaderCell: {
    fontSize: 5,
    fontFamily: "Helvetica-Bold",
    color: "#1D2939",
    padding: "3px 2px",
    textAlign: "left",
  },
  subTableRow: {
    flexDirection: "row",
    borderTop: "0.5px solid #E4E7EC",
  },
  subTableRowAlt: {
    flexDirection: "row",
    borderTop: "0.5px solid #E4E7EC",
    backgroundColor: "#F9FAFB",
  },
  subTableCell: {
    fontSize: 4.5,
    color: "#344054",
    padding: "2.5px 2px",
    textAlign: "left",
  },

  /* ── Sub-table column widths (10 columns) ── */
  colEvent: { width: "7%" },
  colTime: { width: "13%" },
  colLat: { width: "8%" },
  colLng: { width: "8%" },
  colAccuracy: { width: "7%" },
  colDistance: { width: "8%" },
  colAddress: { width: "20%" },
  colDevice: { width: "8%" },
  colLocSrc: { width: "8%" },
  colIp: { width: "13%" },

  /* ── Service address footer ── */
  cardFooter: {
    flexDirection: "row",
    backgroundColor: "#F9FAFB",
    padding: "3px 4px",
    borderTop: "0.5px solid #E4E7EC",
  },
  cardFooterLabel: {
    fontSize: 5,
    fontFamily: "Helvetica-Bold",
    color: "#1D2939",
  },
  cardFooterValue: {
    fontSize: 5,
    color: "#344054",
    marginLeft: 3,
  },

  /* ── Page footer ── */
  footer: {
    position: "absolute",
    bottom: 10,
    left: 14,
    right: 14,
    fontSize: 7,
    color: "#98A2B3",
    flexDirection: "row",
    justifyContent: "space-between",
  },
});
